<template>
	<div class="wrap targeted-page">
		<van-nav-bar
			:title="title"
			@click-left="clickNavBack"
			left-arrow
			id="reset"
			:border="false"
		></van-nav-bar>
		<div class="content">
			<van-grid :border="false" :column-num="2" gutter="12">
				<van-grid-item v-for="item in practiceItems" :key="item.type" @click="openPractice(item)">
					<div class="practice-card">
						<van-icon :name="item.icon" size="34" color="#2db1ac" />
						<div class="practice-name">{{ item.name }}</div>
						<div class="practice-desc">{{ item.desc }}</div>
					</div>
				</van-grid-item>
			</van-grid>
		</div>
	</div>
</template>

<script>
export default {
	name: 'viptargeted',
	data() {
		return {
			title: '专项练习'
		}
	},
	computed: {
		hasLocalCity() {
			const cityCode = this.$route.query.cityCode
			return !!cityCode && cityCode !== 'undefined' && cityCode !== 'null'
		},
		practiceItems() {
			const items = [
				{ type: 'knowledge', name: '按考点练习', desc: '按考点归类练题', icon: 'bookmark-o' },
				{ type: 'chapter', name: '按章节练习', desc: '按章节归类练题', icon: 'notes-o' },
				{ type: 'wrong', name: '易错题', desc: '全局高频错题', icon: 'warning-o' },
				{ type: 'special', name: '专项细分练习', desc: '细分专项集中训练', icon: 'cluster-o' }
			]
			if (this.hasLocalCity) {
				items.splice(2, 0, { type: 'local', name: '地方考题', desc: '按当前城市地方题库练习', icon: 'location-o' })
			}
			return items
		}
	},
	methods: {
		clickNavBack() {
			this.$router.go(-1)
		},
		openPractice(item) {
			this.$router.push({
				path: '/viptargetedlist',
				query: {
					type: item.type,
					title: item.name,
					subject: this.$route.query.subject,
					categoryId: this.$route.query.categoryId,
					cityCode: this.$route.query.cityCode,
					appNo: this.$route.query.appNo
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.van-nav-bar {
	background-color: #2db1ac !important;
}

::v-deep .van-nav-bar .van-icon,
::v-deep .van-ellipsis {
	color: #fff;
}

.targeted-page {
	min-height: 100vh;
	background: #f7f8fa;
}

.content {
	padding: 20px;
}

.practice-card {
	height: 140px;
	padding: 18px 12px;
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 8px 24px rgba(45, 177, 172, 0.1);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.practice-name {
	margin-top: 12px;
	font-size: 16px;
	font-weight: 600;
	color: #333;
}

.practice-desc {
	margin-top: 8px;
	font-size: 12px;
	line-height: 1.5;
	color: #888;
	text-align: center;
}
</style>
